export default "__VITE_ASSET__BGfOXhEi__"